// eslint-disable-next-line
export const hasEnoughFieldsAndTimeslots = (competition = {}, teams = []) => {
  const { fields = [], timeslots = [] } = competition;

  const minimumCombinations = teams.length / 2;
  const totalCombinations = timeslots.length * fields.length;

  return totalCombinations >= minimumCombinations;
};
